import { Repository } from "./adapters/repository";

import * as createCalendarExportLink from "./useCases/createCalendarExportLink";
import * as retrieveCalendarExportLinks from "./useCases/retrieveCalendarExportLinks";

enum UseCases {
  createCalendarExportLink = "createCalendarExportLink",
  retrieveCalendarExportLinks = "retrieveCalendarExportLinks",
}

interface Core {
  [UseCases.createCalendarExportLink]: createCalendarExportLink.Interactor;
  [UseCases.retrieveCalendarExportLinks]: retrieveCalendarExportLinks.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.createCalendarExportLink]:
      createCalendarExportLink.createInteractor(dependencies.repository),
    [UseCases.retrieveCalendarExportLinks]:
      retrieveCalendarExportLinks.createInteractor(dependencies.repository),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
